<template>
  <div class="content">
    <Sticky :offset-top="0" class="top_bar">
      <JNav :title="$t('Cart.text.one')" />
      <div class="money_info_wrap">
        <div class="money_content">
          <div class="left money_item">
            <div class="item_content">
              <div class="title">{{ $t("newAdd.blance") }}</div>
              <div class="data">
                {{ $money(userInfo.money || 0, false) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <van-tabs ref="tabWrap" v-model="tabActive" @change="tabChange" color="var(--theme)"
        title-inactive-color="var(--gray1)" title-active-color="var(--theme)">
        <van-tab v-for="(item, index) in statusData" :title="item.title" :name="item.value" :key="index"></van-tab>
      </van-tabs>
    </Sticky>
    <div class="wrap">
      <van-list v-model="loading" :finished="!finished" ref="listRef" offset="50" :finished-text="$t('Hint.notMore')"
        :loading-text="$t('Hint.loading')" @load="getTaskOrder">
        <div class="nomore" v-if="!newList.length && !listLoading">
          <img src="../../assets/Img/null/null.png" alt="" />
        </div>
        <div class="goods" v-for="(item, index) in newList.filter((a) => a.status != 5)" :key="index"
          :style="index == 0 ? 'margin-top: calc(8rem / 16)' : ''">
          <div class="good_content">
            <div class="bottom">
              <div class="left">
                <img v-if="merchants.find((mitem) => mitem.type === item.type)"
                  :src="merchants.find((mitem) => mitem.type === item.type).picture" alt="" />
              </div>
              <div class="right">
                <div class="title">
                  <span class="label">{{ $t("orderDetails.title.expect") }}:&nbsp;</span>
                  <span class="value">{{ item.expect }}</span>
                </div>
                <div class="title">
                  <span class="label">{{ $t("order.typeTitle") }}:&nbsp;</span>
                  <span class="value">{{ item.typeCn }}</span>
                </div>
                <div class="price">
                  <span class="label">{{ $t("order.totalPrice") }}:&nbsp;</span>
                  <span class="value">{{ item.totalMoney }}</span>
                </div>
                <div class="win" :style="item.type.indexOf('qq') > -1 ? { display: 'flex', alignItems: 'center' } : {}">
                  <span class="label">{{ $t("orderDetails.title.inType") }}: &nbsp;</span>
                  <template v-if="item.method == 'hl-dwd'">
                    <div class="qq_imgs">
                      <img class="img" v-for="val, num in item.code.split('')" :key="num"
                        :src="require(`../../assets/new/game/qq_${val}.png`)" alt="">
                    </div>
                  </template>
                  <template v-else>
                    <template v-if="item.code_cn.includes(',')">
                      <div class="_cn" v-for="val, num in item.code_cn.split(',')" :key="num">
                        <template v-if="val">
                          <div class="_num">{{ num + 1 }}</div>
                          <div class="_val">{{ val }}</div>
                        </template>
                      </div>
                    </template>
                    <span class="value" v-else>{{ item.code_cn }}</span>
                  </template>
                </div>
                <div class="win">
                  <span class="label">{{ $t("order.winPrice") }}: &nbsp;</span>
                  <span class="value">{{ item.winMoney }}</span>
                </div>
                <div class="status">
                  <span class="label">{{ $t("order.status") }}:&nbsp;</span>
                  <span class="ball_wrap" :class="item.type.indexOf('qq') > -1 ? 'ball_qq' : ''"
                    v-if="item.status == '已开奖'">
                    <template v-if="item.type.indexOf('qq') > -1">
                      <div class="qq_img" v-for="item, index in item.open.dwd" :key="index">
                        <img class="_img" :src="require(`../../assets/new/game/qq_${item}.png`)" alt="">
                      </div>
                    </template>
                    <template v-else-if="item.type.indexOf('hl') > -1">
                      <div class="ball_wraps">
                        <div class="ball_img" v-for="item, index in item.open.dwd" :key="index">
                          <img class="img" :src="require(`../../assets/icon/dice/${item}.png`)" alt="">
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div class="ball" v-for="(item, index) in item.open.dwd" :key="index">{{ item }}</div>
                    </template>
                  </span>
                  <span class="value" v-else>{{ getStatus(item) }}</span>
                </div>
                <div class="time">{{ dateEvent(item.indate) }}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div style="height: calc(200rem / 16)"></div> -->
      </van-list>
    </div>
  </div>
</template>

<script>
import {
  Checkbox,
  CheckboxGroup,
  Card,
  SubmitBar,
  Toast,
  Icon,
  List,
  Cell,
  progress,
  Popup,
  NoticeBar,
  CountDown,
  Tabs,
  Tab,
  Sticky,
} from "vant";
import JNav from "@/components/JNav";
import Tabbar from "@/components/Tabbar";
import { domain, $get, $post } from "@/utils/request";
import { REQUEST_API } from "@/http/api";
import { countTime, getMyTime, deciTurnMoney } from "@/utils/tools";
import { formatDate } from "@/utils/tools";
import verConfig from "@/utils/verConfig";

export default {
  components: {
    [Card.name]: Card,
    [Checkbox.name]: Checkbox,
    [SubmitBar.name]: SubmitBar,
    [CheckboxGroup.name]: CheckboxGroup,
    [Icon.name]: Icon,
    [List.name]: List,
    [Cell.name]: Cell,
    [progress.name]: progress,
    [Popup.name]: Popup,
    [NoticeBar.name]: NoticeBar,
    [CountDown.name]: CountDown,
    Tabbar,
    Toast,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    JNav,
    Sticky,
  },

  data() {
    this.statusData = [
      { title: this.$t("order.status.all"), value: 0 },
      { title: this.$t("order.status.waiting"), value: 1 },
      { title: this.$t("order.status.done"), value: 2 },
      // { title: "已关闭", value: 4 },
    ];
    return {
      tabActive: 0,
      verConfig,
      domain: domain,
      buyLoading: -1,
      listLoading: false,
      tableKey: 0,
      statusKey: null,
      list: [],
      loading: false,
      finished: true,
      isBuyFailShow: false,
      isBuyFailNotMoneyShow: false,
      percentage: 0,
      level: 1,
      pageNo: 1,
      buyGoodsForm: {}, // 购买当前商品信息，可用可不用
      interval: "",
      pageNow: 0,
      newList: [],
      userInfo: {},
      // merchants: [],
      tabTop: 0,
    };
  },

  computed: {
    totalPrice() {
      return this.goods.reduce(
        (total, item) =>
          total + (this.checkedGoods.indexOf(item.id) !== -1 ? item.price : 0),
        0
      );
    },
    merchants() {
      return this.$store.getters.AllGameList || [];
    }
  },
  created() {
    this.getUserInfo();
  },
  mounted() {
    this.initTitlePosition();
    this.tabTop = this.$refs.tabWrap.$el.offsetTop;
  },
  methods: {
    async refresh() {
      return new Promise((resolve, reject) => {
        this.pageNow = 0;
        this.finished = false;
        this.getTaskOrder(
          (res) => {
            return resolve(res);
          },
          (err) => {
            return reject(err);
          }
        );
      });
    },
    tabChange(name, title) {
      this.refresh();
    },
    dateEvent(indate) {
      return formatDate("", indate);
    },
    getUserInfo() {
      Toast.loading({
        forbidClick: true,
        duration: 0,
      });
      this.$api.getUserInfo(
        (res) => {
          this.userInfo = res;
          Toast.clear();
        },
        (err) => {
          Toast.clear();
        }
      );
    },
    initTitlePosition() {
      if (this.tableKey > 2) {
        let title_wrap = document.querySelector(".classify");
        title_wrap.scrollLeft = document.documentElement.clientWidth;
      }
    },
    // 状态判断
    getStatus(item) {
      if (!item) return;
      const { status, open } = item;
      switch (status) {
        case "待开奖":
          return this.$t("status.waiting");
          break;
        case "已开奖":
          const data = open["hz-hz-dxds"] || (open.dxds && open.dxds[0]) || {};
          // console.log(data, open["hz-hz-dxds"], open.dxds);
          let res = "";
          for (const key in data) {
            if (Object.hasOwnProperty.call(data, key)) {
              const value = data[key];
              res += "\n" + this.getStatusText(value);
            }
          }
          // res = this.getStatusText(data.dx);
          // res += "\n" + this.getStatusText(data.ds);
          return res;
          break;
        case "开奖出错":
          return this.$t("status.fail");
          break;
        default:
          return "";
          break;
      }
    },
    getStatusText(text) {
      switch (text) {
        case "大":
          return this.$t("open.big");
          break;
        case "小":
          return this.$t("open.small");
        case "单":
          return this.$t("open.single");
        case "双":
          return this.$t("open.double");
        default:
          return text;
      }
    },
    async getTaskOrder(success, fail) {
      this.pageNow++;
      let params = {
        page: this.pageNow,
        status: this.tabActive,
      };
      try {
        Toast.loading();
        const res = await $post("/lottery/order", params);
        const { ret, msg, data } = res.data;
        Toast.clear();
        if (this.pageNow == 1) {
          this.newList = data.lists;
        } else {
          this.newList = [...this.newList, ...data.lists];
        }
        this.finished = data.hasMorePages;
        this.loading = false;
        if (success) {
          success(data);
        }
      } catch (error) {
        this.loading = false;
        this.pageNo--;
        if (fail) {
          fail(error);
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
// @Color: #e23d6d;
@Color: var(--theme);
@comRadius: 10px;
// @comBG: linear-gradient(#093958, #022c47);
@comBG: #fff;
@wrapPadding: calc(12rem / 16);

// 弹性布局
.flex(@JC: center; @FW: nowrap; @AI: center; @FD: row) {
  display: flex;
  flex-wrap: @FW;
  flex-direction: @FD;
  justify-content: @JC;
  align-items: @AI;
}

// 文字超出省略号
.text-overflow(@num: 1) {
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: @num;
}

.content {
  // height: calc(100vh - (50rem / 16));
  min-height: 100vh;
  // background: rgb(248, 248, 248);
  overflow: hidden;
  background-color: var(--bg);

  .top_bar {
    background: var(--bg);
  }

  .ball_wrap {
    // margin-left: calc(-4rem / 16);

    // display: flex;
    .ball {
      text-indent: 0;
      text-align: center;
      border-radius: 50%;
      width: calc(26rem / 16);
      line-height: calc(26rem / 16);
      height: calc(26rem / 16);
      margin: 1px;
      background: var(--theme);
      color: #000;
      display: inline-block;
      background-image: url("~@/assets/icon/game_ball.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }

    .ball_wraps {
      display: flex;
      align-items: center;
      gap: calc(8rem / 16);

      .ball_img {
        .img {
          width: calc(26rem / 16);
          height: calc(26rem / 16);
          display: block;
        }
      }
    }
  }

  .status {
    line-height: 30px;
    display: flex;
  }

  .ball_qq {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    .qq_img {
      ._img {
        width: 30px;
        height: 30px;
        display: block;
      }
    }
  }

  >.title {
    color: var(--textColor);
    height: calc(49rem / 16);
    display: flex;
    align-items: center;
    justify-content: center;
    background: @Color;
    font-weight: 400;
    font-size: calc(18rem / 16);
    position: relative;
    width: 100%;
    margin-bottom: calc(12rem / 16);
  }

  .money_info_wrap {
    background: var(--bg);
    overflow: hidden;
    padding: @wrapPadding @wrapPadding @wrapPadding;
    position: relative;
    min-height: calc(26rem / 16);

    >.line_center_wrap {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;

      >.line_center {
        width: 1px;
        height: 80%;
        background-color: rgb(226, 226, 226);
      }
    }

    >.money_content {
      // width: 100%;
      // height: 100%;
      display: flex;
      // justify-content: space-between;
      justify-content: center;
      align-items: center;
      background: @comBG;
      padding: calc(@wrapPadding * 1.5) 0;
      border-radius: @comRadius;
      background: linear-gradient(90deg, #bead6e, #99793a);

      >.money_item {
        width: 50%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        >.item_content {
          padding: 0 calc(6rem / 16);
          text-align: center;
          line-height: 1.5;
          font-weight: bold;

          >.title {
            font-size: calc(14rem / 16);
            // color: #b8ecff;
            // color: var(--gray1);
            color: var(--light);
          }

          >.data {
            margin-top: calc(3rem / 16);
            font-size: calc(16rem / 16);
            color: @Color;
            color: var(--light);
          }
        }
      }
    }
  }

  >.hint {
    width: 100%;
    padding: calc(4rem / 16) 0;
    background-color: @Color;
    color: var(--textColor);
    text-align: center;
    font-size: calc(12rem / 16);
  }

  .placeholder {
    width: 100%;
    height: calc(12rem / 16);
    background-color: rgb(248, 248, 248);
  }

  :deep(.van-tabs) {
    .van-tabs__wrap {
      padding: @wrapPadding;
      background-color: var(--bg);

      .van-tabs__line {
        display: none;
      }

      .van-tabs__nav {
        // background: @comBG;
        background: transparent;

        .van-tab {
          @gap: calc(10rem / 16);
          width: calc((100% - @gap * 2) / 3);
          background: linear-gradient(90deg, #ffad17, #ffe28b);
          padding: 0;
          flex: none;
          margin-left: @gap;
          color: var(--textColor) !important;
          border-radius: 6px;

          &:nth-of-type(1) {
            margin-left: 0;
          }
        }

        .van-tab--active {
          color: var(--light) !important;
          background: linear-gradient(90deg, #62aaff, #b8daff);
        }
      }
    }
  }

  >.wrap {
    background: var(--bg);
    width: 100%;
    // overflow: hidden;
    // overflow-y: auto;

    :deep(.van-list) {
      // min-height: 80vh;
    }

    .placeholder {
      height: calc(12rem / 16);
      background: rgb(248, 248, 248);
    }

    .nomore {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      >img {
        width: 160px;
        height: 160px;
        display: block;
      }
    }

    .goods {
      // width: 100%;
      // height: calc(145rem / 16);
      margin: @wrapPadding;
      border-radius: @comRadius;

      >.good_content {
        height: 100%;
        padding: 0 calc(16rem / 16);
        background: var(--navBg);
        border-radius: @comRadius;

        >.top {
          width: 100%;
          display: flex;
          justify-content: space-between;
          font-size: calc(14rem / 16);
          font-weight: bold;
          padding: calc(8rem / 16) 0;

          >.price {
            color: @Color;
          }

          >.shop_name {
            color: #eaad5f;
          }

          >.tobuy {
            color: var(--textColor);
            padding: calc(6rem / 16) calc(6rem / 16);
            background-color: @Color;
            border-radius: 4px;
          }
        }

        >.bottom {
          width: 100%;
          display: flex;
          // justify-content: space-between;
          align-items: center;
          padding: calc(8rem / 16) 0;
          line-height: 1;

          >.left {
            max-width: 40%;
            width: 24vw;
            height: 24vw;
            display: flex;
            justify-content: center;
            align-items: center;

            >img {
              width: 20vw;
              height: 20vw;
              border-radius: 2px;
            }
          }

          >.right {
            display: flex;
            flex-direction: column;
            // align-items: flex-end;
            justify-content: space-between;
            margin-left: calc(20rem / 16);
            // max-width: 60%;
            font-size: calc(14rem / 16);
            padding: calc(10rem / 16);
            flex-grow: 1;

            >div {
              margin-top: 4px;

              &:nth-child(1) {
                margin-top: 0;
              }
            }

            .label {
              // color: var(--grey);
              color: var(--textColor);
            }

            .value {
              color: var(--light);
            }

            .win {
              display: flex;
              flex-wrap: wrap;

              ._cn {
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                margin: 0 5px 5px 0;
                color: #fff;

                ._num {
                  border: 2px solid #fff;
                  width: 18px;
                  height: 18px;
                  border-radius: 50%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-size: 13px;
                  line-height: 1;
                  font-weight: 600;
                }

                ._val {
                  margin-left: 3px;
                }
              }

              .img {
                width: 30px;
                height: 30px;
                display: block;
              }
            }

            >.return {
              color: @Color;
              font-size: calc(14rem / 16);
              margin-bottom: calc(12rem / 16);
            }

            >.desc {
              color: #666;
              font-size: calc(12rem / 16);
              margin-bottom: calc(38rem / 16);
              max-width: 100%;
              word-break: break-all;
            }

            >.time {
              color: var(--textColor);
              font-size: calc(12rem / 16);
            }
          }
        }
      }

      >.vantActive {
        width: 100%;
      }
    }
  }

  .block {
    display: inline-block;
    width: 22px;
    color: var(--textColor);
    font-size: 12px;
    text-align: center;
    background-color: #b36900;
  }
}

.qq_imgs {
  display: flex;
  flex-wrap: wrap;
  gap: calc(5rem / 16);
}
</style>
